import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const InsuranceForm = (props) => {

    const initialFormData = {
        insurance: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);
    //const navigate = useNavigate();

    useEffect(() => {
        if (props.insvalue && props.insvalue.insurance_id) {
            const { insurance, is_active, insurance_id } = props.insvalue;
            setFormData({
                insurance: insurance || "",
                isactive: is_active == 1 || is_active === true,
                id: insurance_id || ""
            });
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        } else {
            setFormData(initialFormData);
            setButtonStatus(mapYourMedsConstant.ADD_ACTION);
        }
    }, [props.edittrigger, props.insvalue]);

    const isAddMode = buttonStatus === "Add" || buttonStatus === mapYourMedsConstant.ADD_ACTION;

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsInsuranceUrl = isAddMode ? `${process.env.REACT_APP_SERVER_URL}/patients/add-patient-insurance` :
            `${process.env.REACT_APP_SERVER_URL}/patients/update-patient-insurance`;

        let pelmedsInsuranceData = isAddMode ? 
            { "name": formData.insurance, "group_id": localStorage.getItem("groupId") || '', "is_active": 1 } :
            { "name": formData.insurance, "group_id": localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id };

        const { data } = await axios.post(pelmedsInsuranceUrl, pelmedsInsuranceData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success("Insurance Info added/updated successfully");
        }
        else {
            toast.info("Error while adding Insurance Info");
        }

        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");

        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Insurance Name</Form.Label>
                        <Form.Control
                            placeholder='Insurance Name'
                            value={formData.insurance}
                            name="insurance"
                            size="sm"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            size="sm"
                            disabled={!formData.insurance}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={isAddMode ? true : formData.isactive}
                            disabled={isAddMode}
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form >
    );
};
export default InsuranceForm;

